// extracted by mini-css-extract-plugin
export default {"header":"MainNavigation_header__9GlP5","list":"MainNavigation_list__1U+0a","active":"MainNavigation_active__5miqt"};